import { Stack, Typography } from "@mui/material"
import { useEffect, useState, useRef } from "react";
import LassoStepper from "../../components/LassoStepper";
import { colours } from "../../StyleConstants";
import Assessment from "./Assessment";
import TrainingMaterial from "./TrainingMaterial";
import { useGetDUCInfoQuery } from "../../api/ducApiSlice";
import { useUserInfoQuery } from "../../api/userApiSlice";
import { useNavigate } from "react-router-dom";


export enum TrainingProcessSteps {
    Training = 0,
    Assessment = 1,
}

export const stepLabelsTrain = [
    "TRAINING MATERIAL",
    "ASSESSMENT",
];

const TrainingProcess = () => {
    const [curStep, setCurStep] = useState(TrainingProcessSteps.Training)
    const hasRefetched = useRef(false);
    const { data: userData } = useUserInfoQuery({}, {
        // Add caching to prevent unnecessary refetches
        refetchOnMountOrArgChange: false,
        refetchOnFocus: false,
        refetchOnReconnect: false
    });
    const email = userData?.email;
    const { data: ducData, refetch } = useGetDUCInfoQuery({ email }, {
        skip: !email, // Skip the query if email is not available
        // Add caching to prevent unnecessary refetches
        refetchOnMountOrArgChange: false,
        refetchOnFocus: false,
        refetchOnReconnect: false
    });
    const oldStatus = localStorage.getItem('status')
    const navigate = useNavigate();


    useEffect(() => {
        if(ducData?.GENERAL?.[0]?.status !== oldStatus){
            navigate("/duc")
        }
    }, [ducData, oldStatus, navigate]);

    // Only refetch once when email becomes available
    useEffect(() => {
        if(email && !hasRefetched.current) {
            refetch();
            hasRefetched.current = true;
        }
    }, [email, refetch]);


    const renderStepComponent = () => {
        switch (curStep) {
        case TrainingProcessSteps.Training: {
            return <TrainingMaterial setCurStep={setCurStep} />
        }

        case TrainingProcessSteps.Assessment: {
            return <Assessment />
        }
        }
    }


    return (
        <Stack flexDirection="column" gap={4} height="100%" marginX="50px">
            <Typography
                variant="h3"
                fontWeight="600"
                fontSize="40px"
                textAlign="center"
                color={colours.midnightBlue.blue}>
                NBDC Responsible Data and Biospecimen Use Training
            </Typography>
            <LassoStepper activeStep={curStep} stepLabels={stepLabelsTrain} />
            {renderStepComponent()}
        </Stack>
    )

}

export default TrainingProcess;
